import { render, staticRenderFns } from "./LsFolderStructure.vue?vue&type=template&id=67877352&"
import script from "./LsFolderStructure.vue?vue&type=script&lang=js&"
export * from "./LsFolderStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports